import {SET_CURRENT_USER, SET_USER_OTP, SET_USER_PROFILE, USER_LOADING} from "../actions/types";

const isEmpty = require("is-empty");

const initialState = {
  isAuthenticated: false,
  user: {},
  userProfile:{},
  loading: false
};

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_CURRENT_USER:
      return {
        ...state,
        isAuthenticated: !isEmpty(action.payload),
        user: action.payload
      };
    case SET_USER_PROFILE:
      return {
        ...state,
        userProfile: action.payload.userProfile
      };
    case SET_USER_OTP:
      return {
        ...state,
        userOTP: action.payload.userOtp
      };
    case USER_LOADING:
      return {
        ...state,
        loading: true
      };
    default:
      return state;
  }
}
